export default __webpack_public_path__ + "static/banner_back-93da049cd5d12b8982f4ea0a0eb3e078.webp";